// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3qjBY","disabled":"FileBtn_disabled__31g6N","warn":"FileBtn_warn__1YvIO","fade":"FileBtn_fade__3_bTu"};